import { createDashboardRoute } from "@components-common/routes";
const basePath = "/students";

const typ = {
  baseId: "route" as const,
  section: "students" as const,
  basePath: "/students" as const
}

export const studentsAreaRoutes = {
  dashboard: createDashboardRoute<typeof typ["section"]>(typ.section,{basePath,roles:['STUDENT']})
}

export type StudentsAreRouteIds = typeof studentsAreaRoutes[keyof typeof studentsAreaRoutes]["id"];
